<template>
  <div>
    <van-nav-bar
        title="返利价保"
        left-arrow
        class="my-nav"
        :fixed="true"
        @click-left="$router.back(-1)"
    />

    <div class="body">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div class="card">
          <div>
            <div class="title">xxx</div>
            <div class="amount">xxx</div>
          </div>
          <div>
            <div class="title">xxx</div>
            <div class="amount">xxx</div>
          </div>
          <div>
            <div class="title">xxx</div>
            <div class="amount">xxx</div>
          </div>
        </div>
        <van-search
            class="search-warp"
            v-model="value"
            show-action
            placeholder="请输入单据名称"
            @search="onSearch"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <div class="tabs">


          <van-tabs v-model="active">
            <van-tab title="标签 1"></van-tab>
            <van-tab title="标签 2"></van-tab>
          </van-tabs>
          <van-dropdown-menu>
            <van-dropdown-item v-model="value1" :options="option1"/>
          </van-dropdown-menu>
        </div>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <van-cell v-for="item in list" :key="item" :title="item" value="内容" label="描述信息"/>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import {getBillsInfo} from "../../api/balance";

export default {
  data() {
    return {
      value: 1,
      active: 2,
      data: [
        {
          title: 'xxx'
        }
      ],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      value1: 0,
      option1: [
        {text: '全部', value: 0},
        {text: '待确认', value: 1},
        {text: '待发放', value: 2},
        {text: '已发放', value: 3},
      ],
    };
  },
  mounted() {
  },
  methods: {
    onSearch() {
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
    onRefresh() {
      this.list = []
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
      this.refreshing = false
    },
  }
};
</script>

<style lang="less" scoped>
.body {
  margin: 45px 0;
}

::v-deep .van-dropdown-menu__bar {
  box-shadow: none;
}

.card {
  background: #1989fa;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  color: #fff;
  padding: 20px;
  text-align: center;

  .amount {
    font-size: 0.8em;
  }

}

.tabs {
  display: grid;
  grid-template-columns: 2fr 1fr;
  box-shadow: 0 5px 5px #eee;
  margin-bottom: 5px;
}

.search-warp {
  //background: #eee;
  border-bottom: 1px solid #eee;
}

.van-cell {
  color: #333;
}
</style>
